import { IArgumentType } from '../functions/utils';
import { InferenceError } from '../errors';
import { IFunctionToken } from '../typings/token';
import { isDigit, isNumber, isStringLike, isBoolean, TypeGenerator } from '../utils/type';


// 条件分支
export function IF_ELSE(args: IArgumentType[], token: IFunctionToken) {
  const functionName = token.formatName;

  if (args.length !== 3) {
    throw new InferenceError('function-argument-error', `${functionName} 函数参数个数必须为三个`, token.position);
  }

  const conditionArg = args[0];

  if (!isBoolean(conditionArg, false)) {
    throw new InferenceError('function-argument-error', `${functionName} 函数第一个参数必须为布尔类型`, token.position);
  }

  const ifArg = args[1];
  const elseArg = args[2];

  // 如果一个为 Number 一个为 Integer 则返回 Number
  if (isDigit(ifArg, false) && isDigit(elseArg, false)) {
    if (isNumber(ifArg, false)) {
      return ifArg;
    }
    if (isNumber(elseArg, false)) {
      return elseArg;
    }
    return ifArg;
  }

  if (isDigit(ifArg, true) && isDigit(elseArg, true)) {
    if (isNumber(ifArg, true)) {
      return ifArg;
    }
    if (isNumber(elseArg, true)) {
      return elseArg;
    }
    return ifArg;
  }

  // 如果一个为 String 一个为 Url 则返回 String
  if (isStringLike(ifArg, false) && isStringLike(elseArg, false)) {
    if (ifArg.type !== elseArg.type) {
      return TypeGenerator.String();
    }
    return ifArg;
  }
  // 如果一个为 String 一个为 Url 则返回 String
  if (isStringLike(ifArg, true) && isStringLike(elseArg, true)) {
    if (ifArg.type !== elseArg.type) {
      return TypeGenerator.StringArray();
    }
    return ifArg;
  }

  // 复杂类型如Enum类型、Tree类型、Array类型，需要是指向同一个对象
  if (ifArg.type === elseArg.type && ifArg.isArray === elseArg.isArray) {
    if (['Enum', 'Tree'].includes(ifArg.type)) {
      if (!ifArg.fqn || ifArg.fqn !== elseArg.fqn) {
        throw new InferenceError('function-argument-error', `${functionName} 函数的第二和第三个参数对应的数据模型不匹配`, token.position);
      }
    } else if (['Id'].includes(ifArg.type)) {
      if ((ifArg.ownerFqn || elseArg.ownerFqn)) {
        if (ifArg.ownerFqn && elseArg.ownerFqn) {
          if (ifArg.ownerFqn !== elseArg.ownerFqn) {
            throw new InferenceError('function-argument-error', `${functionName} 函数的第二和第三个参数为Id类型，但其所属模型不匹配`, token.position);
          }
        } else {
          return ifArg.ownerFqn ? ifArg : elseArg;
        }
      }
    }
    return ifArg;
  }

  throw new InferenceError('function-argument-error', `${functionName} 函数的第二和第三个参数的类型必须一致`, token.position);
}
